function AboutPage() {
  return (
    <>
      <p className="eyebrow">About</p>
      <h1>About Vortax</h1>
      <p className="subtitle">
        An indie startup studio for software and games.
      </p>
      <p className="content">
        Vortax is a compact studio that turns ideas into polished digital
        experiences. Our work combines engineering discipline with game-inspired
        creativity.
      </p>
      <p>
        contact us at <b>vortaxgamestudio@gmail.com</b>
      </p>
    </>
  );
}

export default AboutPage;
